export default "__VITE_ASSET__CQdmVAfp__"